export default __webpack_public_path__ + "static/media/appreciation-4.3d7950de.jpg";